import styled from "styled-components";

const PlaylistWrapper = styled.div`
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease-out, visibility 0s linear 0.15s;

    &.fade {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.15s ease-out, visibility 0s linear 0s;
    }

    .book-container {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        margin: 0;
        z-index: 50;
        position: relative;

        .model-playlist-tools {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            position: absolute;
            top: 0;
            right: -1.5rem;

            width: 3.5rem;
            height: 12rem;
            z-index: 500;

            background-color: ${(props) => props.theme.LayoutBodyBackground};
            /* border: 1px solid ${(props) => props.theme.BorderColor}; */

            .page-counter {
                display: flex;
                justify-content: flex-end;
                font-size: 0.9rem;
                text-transform: uppercase;
                background-color: ${(props) => props.theme.LayoutBodyBackground};
                padding: 0.5rem 1rem;
                z-index: 400;
            }

            .print-button {
                font-size: 1.75rem;
                cursor: pointer;
            }
            .download-button {
                font-size: 1.75rem;
                cursor: pointer;
            }
        }

        @media (min-width: 900px) {
            padding: 0 2rem;
        }

        #hiddenbook {
            display: none;
        }

        .book-viewer {
            position: relative;

            &.model-book-classic-mobile {
                display: none;
            }

            .picbox {
                position: relative;
                margin-left: 1rem;
                margin-right: 1rem;
                display: flex;
                justify-content: center;
                align-items: center;

                &.picbox-double {
                    div {
                        margin: 0 3px;
                    }
                }

                video {
                    background-color: #000;
                }
            }

            .book-next,
            .book-prev {
                opacity: 0.6;
                /* text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777; */
                position: absolute;
                width: 5rem;
                height: 5rem;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 3rem;
                z-index: 400;
                cursor: pointer;

                &:hover {
                    opacity: 1 !important;
                }
            }

            .book-next {
                right: -1.5rem;
                top: 50%;
                transform: translate3d(50%, -50%, 0);
            }

            .book-prev {
                left: -2rem;
                top: 50%;
                transform: translate3d(-50%, -50%, 0);
            }
        }
    }

    .hover-hotspot {
        position: absolute;
        height: 100%;
        width: calc(50% + 60px);
        top: 0px;
    }

    .hover-left {
        left: -60px;
    }

    .hover-right {
        right: -60px;
    }
`;

const PlaylistWrapperMobile = styled.div`
    div.playlist-carousel-wrapper {
        background-color: #000;
    }

    .playlist-mobile-header {
        padding: 0.5rem 0.25rem;

        h3 {
            text-transform: capitalize;
            font-size: 1.25rem;
            font-weight: ${(props) => props.theme.FontWeightBold};
            padding-right: 1rem;
            margin: 0;
        }
    }

    div.playlist-mobile-documents {
        div.playlist-image-wrapper {
            padding: 0.25rem 0 0 0;
            img {
                width: 100%;
                height: auto;
            }
            .public-description {
                font-size: .85rem;
                padding: .25rem 0 .5rem 0;
                color: ${props => props.theme.TextColor};
            }
        }
        div.playlist-video-wrapper {
            padding: 0.25rem 0 0 0;
        }
    }
`;

const PlaylistWrapperVScroll = styled.div`
    opacity: 1;

    .book-container {
        margin: 0;
        z-index: 50;
        position: relative;

        .model-playlist-tools {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            position: absolute;
            top: 0;
            right: -1.5rem;

            width: 3.5rem;
            height: 10rem;
            z-index: 500;

            background-color: ${(props) => props.theme.LayoutBodyBackground};
            /* border: 1px solid ${(props) => props.theme.BorderColor}; */

            .page-counter {
                display: flex;
                justify-content: flex-end;
                font-size: 0.9rem;
                text-transform: uppercase;
                background-color: ${(props) => props.theme.LayoutBodyBackground};
                padding: 0.5rem 1rem;
                z-index: 400;
            }

            .print-button {
                opacity: 0.6;
                font-size: 1.75rem;
                cursor: pointer;

                &:hover {
                    opacity: 1;
                }
            }
            .download-button {
                opacity: 0.6;
                font-size: 1.75rem;
                cursor: pointer;

                &:hover {
                    opacity: 1;
                }
            }
        }

        @media (min-width: 900px) {
            padding: 0 2rem;
        }

        .book-row {
            background-color: #000;
            margin-bottom: 0.25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            width: ${(props) => `${props.$boxWidth}px`};
            font-size: ${(props) => `${props.$boxHeight}px`};
            height: 1em;

            .book-page {
                height: 100%;
                width: ${(props) => `${props.$imageRatioForWidth}em`};
                background-color: yellow;
                margin: ${(props) => `0 calc(${props.$imageGutter} / 2)`};
                box-sizing: border-box;
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
            }
        }

        .book-row-wide {
            background-color: #000;
            margin-bottom: 0.25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            height: auto;
            width: ${(props) => `${props.$boxWidth}px`};
            //font-size: ${(props) => `${props.$boxHeight}px`};

            .book-page {
                height: auto;
                background-color: yellow;
                width: ${(props) => `calc(${props.$widthForWide}px + ${props.$imageGutter})`};
                margin: ${(props) => `0 calc(${props.$imageGutter} / 2)`};
                box-sizing: border-box;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }
    }
`;

export { PlaylistWrapper, PlaylistWrapperMobile, PlaylistWrapperVScroll };
